import styled from 'styled-components'
import Flex from 'Components/Flex'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import { BREAK_POINT_LG, BREAK_POINT_MD } from '@CSSVars/variables'
import { OUTLINE_COLOR_LIGHT, LIGHT_BACKGROUND } from '@CSSVars/colors'


export const _InnerContainerFlex = styled(Flex)`
  width: 100%;
  position: relative;
  display: flex;
  align-items: start;
  ${({ listingPage }) => (!listingPage &&
    `
     @media screen and (max-width: ${BREAK_POINT_MD}) {
       align-items: start;
     }
    `)}
  overflow-x: hidden;
`

export const _CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background-color: ${LIGHT_BACKGROUND};
  margin-bottom: 8px;
  border-radius: 10px;
  @media screen and (max-width: 600px) {
    border: none;
    padding: ${({ listingPage }) => (listingPage ?
    '6px 10px' : '11px 8px 10px 11px')};
  }
`

export const _ArchiveCard = styled(AppLinkMobileCtrl)`
  /*next line is for print listing page to avoid breaking cards*/
  break-inside: avoid;
  &:hover {
    cursor: pointer;
  }

  ${({ hideOnPrint }) => (hideOnPrint && `
    @media print {
      display: none;
    }
  `)};

`


export const _ListingImg = styled(AppLinkMobileCtrl)`
  & div:first-of-type {
    display: flex;
    min-height: 100%;
    min-width: 100%;
    background-size: cover;
    ${({ listingPage }) => (listingPage ?
    'width: 52px;' +
      'height: 52px;'
    :
    'width: 70px;' +
      'height: 70px;')}
    border-radius: 10px;
  }

  img {
    //min-width: 100%;
    //min-height: 100%;
    transform: translate(-50%, -50%);
    position: relative;
    left: 50%;
    top: 50%;
    flex: 1;
    height: 100%;
    width: auto;
    background-size: cover;
  }
  //overflow: hidden;
  background-size: cover;

  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    ${({ listingPage }) => (!listingPage && `
    > div {
      width: 70px !important;
      height: 70px !important;
    }
    `)}
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    ${({ listingPage }) => (listingPage && `
    > div {
      width: 65px !important;
      height: 65px !important;
    }
    `)}
    padding: 4px 0;
  }
  @media screen and (max-width: 350px) {
    display: none;
  }


`


export const _PrintToggleBtn = styled.div`
  position: absolute;
  z-index: 200;
  top: 50%;
  right: -48px;
  transform: translate(-50%, -50%);
  padding: 3px;
  border-radius: 50%;
  background: white;
  border: 1px solid ${OUTLINE_COLOR_LIGHT};
  pointer-events: visible;
  @media print {
    display: none;
  }
`

export const _VisibilityIconContainer = styled(Flex)`
  position: relative;
  width: 16px;
  height: 16px;
  .cross_line {
    display: ${({ show }) => (show ? 'none' : 'block')};
  }

`
